$('document').ready(() => {
    const filters = document.querySelector('.filters');

    if (!filters) return;

    const filterList = filters.querySelector('.filters__list');
    const filterItems = filterList.children;


    $('.filters__list-item').each(function() {
        if(!$(this).hasClass('filters__list-item--active')) {
            $(this).children('.filters__list-item-content')
                .slideDown()
                .hide();
        } else {
            $(this).children('.filters__list-item-content')
                .css('display', 'block');
        }
    })
    $('.filters__list').click((e) => {
        let target = $(e.target);
        if(target.hasClass('filters__list-item-title')) {
            target.parent().toggleClass('filters__list-item--active');
            target.siblings('.filters__list-item-content').slideToggle();
        }
    })

    if (document.querySelector('.js-filter-list-btn')) {
        const btn = document.querySelector('.js-filter-list-btn');

        filters.addEventListener('input', (e) => {
            if (e.target.closest('.switch')) return;

            const item = e.target.closest('div');

            btn.style.top = window.innerWidth > 767 ? `${item.offsetTop + item.offsetHeight / 2}px` : 'auto';

            btn.classList.add('active')
        })
    }

    if (filterItems.length > 7 && window.innerWidth > 767) {
        for (let i = 7; i < filterItems.length; i++) {
            const filter = filterItems[i];

            filter.style.display = 'none';
        }

        const btn = document.createElement('button');
        btn.className = 'button filters__list-btnMore';
        btn.textContent = 'Все фильтры';

        switch (window.lang) {
            case 'en':
                btn.textContent = 'All filters';
                break;
        }

        filterList.append(btn);

        btn.addEventListener('click', () => {

            for (let i = 7; i < filterItems.length; i++) {
                const filter = filterItems[i];

                filter.style.display = 'block';
            }

            btn.remove();
        })
    }

    filterList.classList.add('_init');
})
